<template>
  <div id="app" class="flex flex-col min-h-screen">
    <Header />

    <router-view />

    <Footer />
    <WhatsappLink />
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from "@/components/Footer.vue";
import WhatsappLink from '@/components/Buttons/WhatsappLink.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    WhatsappLink
  },
};
</script>

<style>
html {
  scroll-behavior: smooth;
}

html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>